export default [
  {
    title: 'Clínicas y hospitales',
    subtitle: 'Esterilización eficaz y segura.',
    ul: [
      '- Efectivo contra esporas, virus bacterias y hongos',
      '- Es utilizado para esterilizar quirófanos',
      '- No daña acero inoxidable, plástico, hule ni vidrio'
    ],
    image: 'hospital.png'
  },
  {
    title: 'Casas y departamentos',
    subtitle: 'Siéntete seguro en tu casa o departamento',
    ul: [
      '- Elimina el 99% de los agentes patógenos',
      '- No causa ningún riesgo a la salud',
      '- No irrita la piel ni afecta a mascotas',
      '- No daña acero inoxidable, plastico hule o vidrio'
    ],
    image: 'house.png'
  },
  {
    title: 'Restaurantes y hoteles',
    subtitle: 'Seguridad de espacios libres de bacterias',
    ul: [
      '- No desprende vapores nocivos',
      '- No tóxico ni corrosivo',
      '- No daña acero inoxidable. plástico, hule o vidrio'
    ],
    image: 'restaurant.png'
  },
  {
    title: 'Oficinas',
    subtitle: 'Centros de trabajo limpios y sanitizados',
    ul: [
      '- Elimina el 99% de los agentes patógenos',
      '- No tóxico ni corrosivo',
      '- No daña acero inoxidable, plástico, hule o vidrio'
    ],
    image: 'office.png'
  },
  {
    title: 'Fábricas',
    subtitle: 'Áreas de producción sanitizadas',
    ul: [
      '- No tóxico ni corrosivo',
      '- No daña acero inoxidable, plástico, hule o vidrio'
    ],
    image: 'fabric.png'
  },
  {
    title: 'Parques y áreas comunes',
    subtitle: 'Comunidad segura y sanitizada',
    ul: [
      '- No irrita la piel ni afecta a mascotas',
      '- No tóxico ni corrosivo',
      '- No daña acero inoxidable, plástico, hule o vidrio'
    ],
    image: 'park.png'
  },
  {
    title: 'Calles',
    subtitle: 'Seguridad en espacios públicos',
    ul: [
      '- No tóxico ni corrosivo',
      '- No daña acero inoxidable, plástico, hule o vidrio'
    ],
    image: 'street.png'
  },
  {
    title: 'Aerolíneas',
    subtitle: 'Vuelos seguros y confiables',
    ul: [
      '- Elimina el 99% de los agentes patógenos',
      '- No tóxico ni corrosivo',
      '- No daña acero inoxidable, plástico, hule o vidrio'
    ],
    image: 'airline.png'
  }
]
